// src/auth/LoginPage.js
import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import './LoginPage.css';

const LoginPage = () => {
  const { login, register, needsSetup } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      if (needsSetup) {
        await register(email, password, name);
      } else {
        await login(email, password);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <h1 className="login-logo">DansMaPoche</h1>
          <p className="login-subtitle">
            {needsSetup
              ? 'Bienvenue ! Cr\u00e9ez votre compte administrateur.'
              : 'Connectez-vous pour continuer'
            }
          </p>
        </div>

        {error && (
          <div className="login-error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          {needsSetup && (
            <div className="form-field">
              <label htmlFor="name">Nom</label>
              <input
                id="name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Votre nom"
                autoComplete="name"
              />
            </div>
          )}

          <div className="form-field">
            <label htmlFor="email">Identifiant</label>
            <input
              id="email"
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Votre identifiant"
              required
              autoComplete="username"
              autoFocus
            />
          </div>

          <div className="form-field">
            <label htmlFor="password">Mot de passe</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={needsSetup ? '6 caract\u00e8res minimum' : 'Mot de passe'}
              required
              minLength={needsSetup ? 6 : undefined}
              autoComplete={needsSetup ? 'new-password' : 'current-password'}
            />
          </div>

          <button
            type="submit"
            className="login-btn"
            disabled={isSubmitting}
          >
            {isSubmitting
              ? 'Chargement...'
              : needsSetup
                ? 'Cr\u00e9er le compte'
                : 'Se connecter'
            }
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
